import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25990334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 项目登记 ")

export function render(_ctx, _cache) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_arrow_right_outlined = _resolveComponent("arrow-right-outlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _directive_perm = _resolveDirective("perm")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      "active-key": _ctx.value,
      onChange: _ctx.changeTab
    }, {
      rightExtra: _withCtx(() => [
        _renderSlot(_ctx.$slots, "rightButton", {}, () => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            onClick: _ctx.onProjectDesign
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_arrow_right_outlined)
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_perm, '/project/profile/create']
          ])
        ], true)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowStatusArr, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.type,
            tab: item.name + '(' + item.total + ')'
          }, null, 8, ["tab"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["active-key", "onChange"])
  ]))
}